import { render, staticRenderFns } from "./BulkCertificate.vue?vue&type=template&id=7d082628"
import script from "./BulkCertificate.vue?vue&type=script&lang=js"
export * from "./BulkCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports